import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './home-page/home-page.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OtherTaskListComponent } from './other-task-list/other-task-list.component';
import { PayrollTaskListComponent } from './payroll-task-list/payroll-task-list.component';
import { BaseTaskListComponent } from './base-task-list/base-task-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSharedLibraryModule } from '../../ng-shared-library.module';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { TitleComponent } from 'echarts/components';
import { NgxEchartsModule } from 'ngx-echarts';
echarts.use([PieChart, TitleComponent, CanvasRenderer]);

@NgModule({
  declarations: [
    BaseTaskListComponent,
    HomePageComponent,
    OtherTaskListComponent,
    PayrollTaskListComponent
  ],
  imports: [
    BrowserAnimationsModule,
    NgxEchartsModule.forRoot({ echarts }),
    CommonModule,
    FormsModule,
    InfiniteScrollModule,
    NgbModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    RouterModule,
    NgSharedLibraryModule
  ],
  providers: [provideNgxMask()]
})
export class HomePageModule {}
